<template>
  <div>
    <div
      class="header"
      :class="{ active: backShow == 1, active1: backShow == 2, active2: backShow == 3 }"
      @click="toAdBg(homeBg)"
    >
      <div class="wraper" @click.stop="emptyFunc">
        <div class="header-left">
          <router-link @click.native="btnClick(0)" class="main_logo" to="/">
            <img src="/img/logo.png" class="logo" alt="" />
          </router-link>
          <div class="link">
            <div class="tab" @click="btnClick(0)" :class="header === 0 ? 'active-select' : ''">
              <img src="/img/home/home-new.png" alt="" />
              <img class="act" src="/img/home/home-new-act.png" alt="" />
              {{ $t("header.home") }}
            </div>
            <div class="tab" @click="btnClick(1)" :class="header === 1 ? 'active-select' : ''">
              <img src="/img/home/live-new.png" alt="" />
              <img class="act" src="/img/home/live-new-act.png" alt="" />
              {{ $t("header.live-streaming") }}
            </div>
            <div
              class="tab tab-wc"
              v-if="appConfig.wc2026_toggle == 1"
              @click="btnClick(8)"
              :class="header === 8 ? 'active-select' : ''"
            >
              <img src="/img/home/wc-new.svg" alt="" />
              <img class="act" src="/img/home/wc-new-act.svg" alt="" />
              <span class="tab-label">世界杯</span>
            </div>
            <div
              class="tab"
              v-if="preview_switch & 1 || appConfig.live_preview_switch & 1"
              @click="btnClick(10)"
              :class="header === 10 ? 'active-select' : ''"
            >
              <img src="/img/home/yug-new.png" alt="" />
              <img class="act" src="/img/home/yug-new-act.png" alt="" />
              预告
            </div>
            <div class="tab" @click="btnClick(2)" :class="header === 2 ? 'active-select' : ''">
              <img src="/img/home/sais-new.png" alt="" />
              <img class="act" src="/img/home/sais-new-act.png" alt="" />
              赛程
            </div>
            <div
              class="tab"
              @click="btnClick(9)"
              :class="header === 9 ? 'active-select' : ''"
              v-if="appConfig?.private_message_toggle || isSem === 0"
            >
              <img src="/img/home/liaot-new.png" alt="" />
              <img class="act" src="/img/home/liaot-new-act.png" alt="" />
              <span>{{ $t("header.chat") }}</span>
              <span class="note" v-show="unreadTotal">{{ unreadTotal }}</span>
            </div>
            <div
              class="tab"
              @click="openChatAssistant"
              :class="isChatAssistantShow ? 'active-select' : ''"
              v-if="isCustomer && (appConfig?.private_message_toggle || isSem === 0)"
            >
              <img src="/img/home/liaot-new.png" alt="" />
              <img class="act" src="/img/home/liaot-new-act.png" alt="" />
              <span>{{ $t("header.chat-assistant") }}</span>
              <span class="note" v-show="c2cUnreadDisplay">{{ c2cUnreadDisplay }}</span>
            </div>
          </div>
        </div>

        <div class="header-right">
          <div class="search_bar_gray">
            <img :src="require('./img/search_grey.png')" @click="goSearch" style="float: right" />
            <input
              :disabled="false"
              v-model="searchKey"
              :maxlength="10"
              :class="!isHomePage || aplaHeaderBg == 1 ? 'search-input' : ''"
              :placeholder="$t('header.search')"
              name="key"
              type="text"
              v-on:keyup.13="goSearch"
              style="color: #ffffff"
            />
          </div>

          <div class="controller">
            <div class="start-btn" v-if="appConfig?.checkin_switch" @click="toCheckin">
              <span class="icon">
                <img class="img-normal" :src="require('./img/icon_header_6.png')" />
                <img class="img-active" :src="require('./img/icon_header_6_active.png')" />
              </span>
              <p>签到</p>
            </div>
            <div class="start-btn" v-if="appConfig.lottery_switch" @click="toGame">
              <span class="icon">
                <img class="img-normal" :src="require('./img/icon_header_5_active.png')" />
                <img class="img-active" :src="require('./img/icon_header_5.png')" />
              </span>
              <p>游戏</p>
            </div>
            <div
              class="start-btn"
              v-if="appConfig.talent_list_status == 1"
              @click="toRanking"
              target="_blank"
            >
              <span class="icon">
                <img class="img-normal" :src="require('./img/icon_header_1.png')" />
                <img class="img-active" :src="require('./img/icon_header_1_active.png')" />
              </span>
              <p>达人榜</p>
            </div>
            <router-link
              to="/download"
              class="start-btn"
              @mouseover.native="
                showTxt(2);
                showQr = true;
              "
              @mouseout.native="
                showQr = false;
                hoveract = null;
              "
            >
              <span class="icon">
                <img class="img-normal" :src="require('./img/icon_header_2_active.png')" />
                <img class="img-active" :src="require('./img/icon_header_2.png')" />
              </span>
              <p>{{ $t("header.download") }}</p>
              <QrCard
                v-show="showQr"
                style="right: 50%; transform: translate3d(47%, 0, 0); top: 0.54rem"
              />
            </router-link>
            <div class="start-btn" @click.stop="toFocus" target="_blank">
              <span class="icon">
                <img class="img-normal" :src="require('./img/icon_header_3_active.png')" />
                <img class="img-active" :src="require('./img/icon_header_3.png')" />
              </span>
              <p>{{ $t("header.follow") }}</p>
            </div>
            <template v-if="isLiving">
              <div class="start-btn" @click.stop="startLive()">
                <span class="icon"><img :src="require('@/assets/img/gif/live.gif')" /></span>
                <p>{{ $t("header.live") }}</p>
              </div>
            </template>
            <template v-else>
              <div class="start-btn" @click.stop="startLive()">
                <span class="icon">
                  <img class="img-normal" :src="require('./img/icon_header_4_active.png')" />
                  <img class="img-active" :src="require('./img/icon_header_4.png')" />
                </span>
                <p>{{ $t("header.start-live") }}</p>
              </div>
            </template>

            <div
              class="un-login-btn flex-column flex-middle"
              :class="{ block: block && isHomePage }"
              v-if="!userInfo.id"
              @click.stop
              @mouseover="block = false"
            >
              <img class="img-login" :src="require('./img/mine_nav_ziliao_nor.png')" />

              <div
                class="un-login-content"
                :style="{ width: '3rem', height: '4rem', right: '-0.53rem' }"
              >
                <div class="login-content" @click="toggleLogin">
                  <div style="padding: 0.3rem 0.1rem 0.1rem">
                    <el-row>
                      <el-col :span="12" class="flex-column flex-middle-only" style="width: 100%">
                        <img class="icon-img" src="" alt="" style="width: 100%" />
                        <span class="icon-text"></span>
                      </el-col>
                      <el-col :span="12" class="flex-column flex-middle-only" style="width: 100%">
                        <img class="icon-img" src="" alt="" />
                        <span class="icon-text"></span>
                      </el-col>
                      <el-col :span="12" class="flex-column flex-middle-only" style="width: 100%">
                        <img class="icon-img" src="" alt="" />
                        <span class="icon-text"></span>
                      </el-col>
                      <el-col :span="12" class="flex-column flex-middle-only" style="width: 100%">
                        <img class="icon-img" src="" alt="" />
                        <span class="icon-text"></span>
                      </el-col>
                    </el-row>
                    <div class="login-now" @click="toggleLogin">&nbsp;</div>
                    <div
                      class="flex-middle"
                      @click="toggleLogin"
                      style="height: 0.3rem; width: 100%"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="login2">
              <router-link to="/user-center/index">
                <img
                  :src="userInfo.avatar || defaultAvatar"
                  class="avatar"
                  @error="onAvatarError"
                />
              </router-link>

              <div class="un-login-content login-bg" style="height: 3.2rem">
                <div
                  class="login-content"
                  style="width: calc(100% - 0.41rem); height: calc(100% - 0.1rem)"
                >
                  <UserCard :isLiving="isLiving" :userInfo="userInfo" @startLive="startLive" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <RechargeDialog></RechargeDialog> -->
      <!-- <div class="save-destop" @click="installPWA" :disabled="$root.deferredPrompt === false">添加到桌面</div> -->
    </div>
    <div @click.stop="emptyFunc()">
      <start-live-set v-if="isShowLiveSet" :isShow.sync="isShowLiveSet" @closeDialog="closeDialog">
      </start-live-set>
    </div>
    <!-- 聊天助手 -->
    <div class="chat-assistant-modal" v-if="isChatAssistantShow">
      <div class="chat-assistant-panel">
        <div class="chat-assistant-header">
          <div class="title">{{ $t("header.chat-assistant") }}</div>
          <div class="collapse" @click="closeChatAssistant">{{ $t("live-room.hide") }}</div>
        </div>
        <iframe
          class="chat-assistant-iframe"
          :src="chatAssistantUrl"
          frameborder="0"
          allow="clipboard-read; clipboard-write"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { post } from "@/util/http";
import UserCard from "@/components/user-card/user-card.vue";
import StartLiveSet from "@/components/start-live-set/start-live-set";
import QrCard from "@/components/qr-card/qr-card";
import event from "@/event";
import { toMoreActivity } from "@/util/more-activity";
import TIM from "tim-js-sdk";
import { tim } from "@/util/tim";
import { getChannel } from "@/util/channel";
import { buildChatAssistantUrl } from "@/util/common";

export default {
  components: {
    StartLiveSet,
    QrCard,
    UserCard,
  },

  inject: ["reload"],
  data() {
    return {
      aplaHeaderBg: 0.03,
      showQr: false,
      timeOutUserCard: "",
      timeOutQrCard: "",
      showSubNav: false,
      active: "",
      searchKey: "",
      limitPosition: 400,
      isShowLiveSet: false,
      gameUrl: "",
      index: 0,
      hoveract: null,
      hovertitle: null,
      pathname: "",
      homeBg: {},
      block: true,
      isLogoShow: false,
      backShow: 0,
      header: 0,
      language: localStorage.getItem("language"),
      preview_switch: sessionStorage.getItem("preview_switch"),
      isSem: IS_SEM,
      deferredPrompt: false,
      _timListenerBound: false,
      _refreshTimer: null,
      isChatAssistantShow: false,
      chatAssistantUrl: "",
      c2cUnreadTotal: 0,
      _c2cUnreadTimer: null,
    };
  },

  watch: {
    $route(to, from) {
      console.log("route-header", to.path);
      if (to.path == "/home") {
        this.header = 0;
        this.isLogoShow = true;
        this.backShow = 0;
      } else if (to.path == "/liveMatches") {
        this.header = 1;
        this.isLogoShow = false;
        this.backShow = 1;
      } else if (to.path == "/liveMatchesReplay") {
        this.header = 7;
        this.isLogoShow = false;
        this.backShow = 1;
      } else if (to.path == "/schedule") {
        this.header = 2;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (to.path == "/news") {
        this.header = 3;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (/news_detail/.test(to.path)) {
        this.header = 3;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (to.path == "/schedule-preview") {
        this.header = 10;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (to.path == "/user-center/privateChat") {
        this.header = 9;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (to.path == "/worldCup") {
        this.header = 8;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (/scheduleDetail/.test(to.path)) {
        this.header = 2;
        this.isLogoShow = true;
        this.backShow = 3;
      } else if (/liveMatchesTwo/.test(to.path) && from.path == "/liveMatchesReplay") {
        this.header = 7;
        this.isLogoShow = false;
        this.backShow = 1;
      } else if (/liveMatchesTwo/.test(to.path)) {
        this.header = 1;
        this.isLogoShow = false;
        this.backShow = 1;
      } else if (/user-center/.test(to.path)) {
        this.header = 0;
        this.isLogoShow = true;
        this.backShow = 2;
      } else if (/activity/.test(to.path)) {
        this.header = 4;
        this.isLogoShow = true;
        this.backShow = 1;
      } else if (/anchorInfo/) {
        this.header = 0;
        this.isLogoShow = true;
        this.backShow = 2;
      } else {
        this.header = 0;
        this.isLogoShow = true;
        this.backShow = 1;
      }
      sessionStorage.setItem("header", this.header);
    },
    isHomePage(flag) {
      if (flag) this.block = true;
    },
    isTimReady(ready) {
      if (ready) this.loadC2cUnreadCount();
    },
    "userInfo.id"(id) {
      if (id) this.loadC2cUnreadCount();
      else this.c2cUnreadTotal = 0;
    },
  },

  computed: {
    ...mapState([
      "userInfo",
      "defaultAvatar",
      "categories",
      "pageConfig",
      "isHomePage",
      "appConfig",
      "isTimReady",
    ]),
    ...mapGetters(["isLiving", "unreadTotal"]),
    c2cUnreadDisplay() {
      if (!this.c2cUnreadTotal) return "";
      return this.c2cUnreadTotal > 99 ? "99+" : this.c2cUnreadTotal;
    },
    /** getUserInfo.is_customer：1 客服，0 否 */
    isCustomer() {
      return Number(this.userInfo?.is_customer) === 1;
    },
  },

  created() {
    this.header = Number(sessionStorage.getItem("header")) || 0;
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
  },

  // 添加 destroyed 钩子
  destroyed() {
    if (tim && this._timListenerBound) {
      tim.off(TIM.EVENT.MESSAGE_RECEIVED, this.onTimMessage);
      tim.off(TIM.EVENT.MESSAGE_MODIFIED, this.onTimMessage);
      tim.off(TIM.EVENT.CONVERSATION_LIST_UPDATED, this.onC2cConversationUpdated);
      this._timListenerBound = false;
    }

    if (this._refreshTimer) {
      clearTimeout(this._refreshTimer);
    }
    if (this._c2cUnreadTimer) {
      clearTimeout(this._c2cUnreadTimer);
    }
  },

  // 修改 mounted 方法
  async mounted() {
    let tabId = sessionStorage.getItem("header") || 0;
    this.changeHeader(Number(tabId));
    if (localStorage.getItem("userInfo")) {
      this.changeUserInfo(JSON.parse(localStorage.getItem("userInfo")));
      this.getUserInfo();
      this.$store.dispatch("checkAnchorStatus");

      // 只在初始化时调用一次getChatList
      if (!this.$store.state.chatList || this.$store.state.chatList.length === 0) {
        await this.getChatList({ force: true });
      }
    }

    event.$on("start-live", (flag) => {
      console.log("start-live", flag);
      this.isShowLiveSet = flag;
    });

    // 设置TIM消息监听
    this.setupTimListener();
  },

  methods: {
    ...mapMutations([
      "changeHeader",
      "toggleLogin",
      "changeLoginType",
      "toggleDynamicRel",
      "changeUserInfo",
      "changeNavCategoryName",
      "toggleCheckinDialog",
    ]),
    ...mapActions(["getChatList", "getUserInfo"]),

    onAvatarError(e) {
      if (e?.target && e.target.src !== this.defaultAvatar) {
        e.target.src = this.defaultAvatar;
      }
    },

    // 修改 setupTimListener 方法
    setupTimListener() {
      if (tim && !this._timListenerBound) {
        tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onTimMessage);
        tim.on(TIM.EVENT.MESSAGE_MODIFIED, this.onTimMessage);
        tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, this.onC2cConversationUpdated);
        this._timListenerBound = true;
        this.loadC2cUnreadCount();
      } else if (!tim) {
        setTimeout(() => this.setupTimListener(), 500);
      }
    },

    onC2cConversationUpdated() {
      this.scheduleC2cUnreadRefresh();
    },

    // 修改 onTimMessage 方法
    onTimMessage(event) {
      if (!event?.data) return;
      const hasC2C = event.data.some(
        (message) => message.conversationType === TIM.TYPES.CONV_C2C
      );
      if (hasC2C) this.scheduleC2cUnreadRefresh();
    },

    scheduleC2cUnreadRefresh() {
      if (this._c2cUnreadTimer) clearTimeout(this._c2cUnreadTimer);
      this._c2cUnreadTimer = setTimeout(() => {
        this.loadC2cUnreadCount();
      }, 200);
    },

    async loadC2cUnreadCount() {
      const im = tim || this.$store.state.tim;
      if (!im || !this.isTimReady || !this.userInfo?.id) {
        this.c2cUnreadTotal = 0;
        return;
      }
      try {
        const res = await im.getConversationList();
        const list = res?.data?.conversationList || [];
        const total = list
          .filter((item) => item.type === TIM.TYPES.CONV_C2C)
          .reduce((sum, item) => sum + (item.unreadCount || 0), 0);
        this.c2cUnreadTotal = total;
      } catch (e) {
        console.warn("loadC2cUnreadCount error", e);
      }
    },

    installPWA() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt = false;
      }
    },

    btnClick(tag) {
      this.header = tag;
      sessionStorage.setItem("header", tag);
      if (tag === 0) {
        this.$router.push("/home");
      } else if (tag === 1) {
        this.$router.push("/liveMatches");
      } else if (tag === 2) {
        this.$router.push("/schedule");
      } else if (tag === 3) {
        this.$router.push("/news");
      } else if (tag === 4) {
        this.$router.push("/activity");
      } else if (tag === 5) {
        this.$router.push("/mall");
      } else if (tag === 6) {
        this.$router.push("/notice");
      } else if (tag === 7) {
        this.$router.push("/liveMatchesReplay?replay=1");
      } else if (tag === 8) {
        this.$router.push("/worldCup");
      } else if (tag === 9) {
        this.$router.push("/user-center/privateChat");
      } else if (tag === 10) {
        this.$router.push("/schedule-preview");
      }
    },

    openChatAssistant() {
      if (!this.userInfo?.id) {
        this.toggleLogin();
        return;
      }
      if (!this.isCustomer) return;
      const token = localStorage.getItem("token") || this.userInfo?.token || "";
      const uid = localStorage.getItem("id") || this.userInfo?.id || "";
      const channel = getChannel() === "OFFICIAL" ? "official" : "default";
      // 顶部入口不传 toUserId
      this.chatAssistantUrl = buildChatAssistantUrl({ token, uid, channel });
      this.isChatAssistantShow = true;
    },

    closeChatAssistant() {
      this.isChatAssistantShow = false;
      this.chatAssistantUrl = "";
      this.loadC2cUnreadCount();
    },

    toGame() {
      window.open("/game", "game");
    },

    toCheckin() {
      this.toggleCheckinDialog(true);
    },

    toAdBg({ jump_url = "", jump_type = 2 }) {
      if (this.isHomePage) {
        return;
      }
      let url = jump_url || "";
      let v = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/gim;
      if (v.exec(url) && jump_type == 2) {
        window.open(url);
      } else if (url && jump_type == 1) {
        this.$router.push(url);
      }
      if (Number(jump_type) >= 100) toMoreActivity(jump_type);
    },

    async getHomeBanner() {
      const {
        data: { data },
      } = await post({
        url: "/api/home/getLongMenAg",
        data: {
          equipment: 1,
          category: this.pathname == "/home" ? 6 : 11,
        },
      });
      if (data) {
        this.homeBg = data[0] || {};
      }
    },

    goSearch() {
      if (this.searchKey.length > 10) {
        this.$message({
          showClose: true,
          message: "搜索内容最多10个字",
          type: "warning",
        });
        return;
      }
      this.$router.push({
        path: "/keysearch",
        query: {
          keyword: this.searchKey,
        },
      });
      this.searchKey = "";
      return;
    },

    startLive() {
      post({
        url: "/api/user/checkAnchorStatus",
      })
        .then(({ data: { data } }) => {
          let { is_anchor = 0, is_live = 0 } = data;
          if (is_anchor == 0) {
            this.$router.push("/user-center/apply-anchor");
            return;
          }
          if (is_live == 1) {
            if (window.location.href.indexOf(`liveMatchesTwo/${this.userInfo.id}`) > 0) {
              this.reload();
              return;
            }
            this.$router.push(`/liveMatchesTwo/${this.userInfo.id}`);
            if (window.location.href.indexOf("liveMatchesTwo") > 0) {
              this.reload();
            }
          } else {
            this.isShowLiveSet = true;
          }
        })
        .catch((err) => console.log("err: ", err));
    },

    toFocus() {
      if (!localStorage.getItem("userInfo")) {
        this.toggleLogin();
        return;
      }
      this.$router.push("/user-center/focus");
    },

    toRanking() {
      this.$router.push("/ranking");
    },

    closeDialog() {
      this.isShowLiveSet = false;
    },

    async getUserInfo() {
      const { data } = await post({
        url: "/api/user/getUserInfo",
      });
      if (data.status == 0) {
        let { mobile = "" } = data.data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        let keyValue = {
          ...JSON.parse(localStorage.getItem("userInfo")),
          diamond: data.data.diamond,
          gold: data.data.gold,
          mobile: data.data.mobile,
          formatPhone: data.data.formatPhone,
          ...data.data,
          level: Number(data.data.level) || 0,
          process: Number(data.data.process) || 0,
          remainder: Number(data.data.remainder) || 0,
          is_customer: Number(data.data.is_customer) || 0,
        };
        localStorage.setItem("userInfo", JSON.stringify(keyValue));
        this.changeUserInfo({
          ...keyValue,
        });
      }
    },

    showTxt(index) {
      this.hoveract = index;
    },

    showtitleFn(index) {
      this.hovertitle = index;
      console.log(this.hovertitle);
    },
    emptyFunc() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variable.scss";

.header {
  background: transparent;
}

.save-destop {
  color: #ffd800;
  cursor: pointer;
  position: absolute;
  top: 0.2rem;
  right: 0.7rem;
  padding: 0.05rem;
  border: 1px solid #ffd800;
  border-radius: 0.03rem;
}

.note {
  position: absolute;
  top: -0.02rem;
  right: -0.1rem;
  padding: 0 0.05rem;
  min-width: 0.1rem;
  height: 0.2rem;
  line-height: 0.2rem;
  text-align: center;
  border-radius: 0.2rem;
  background: #f64d5c;
  color: #ffffff;
  font-size: 0.12rem;
  margin-left: 0.06rem;
}

.un-login-btn {
  flex-shrink: 0;
  width: 0.5rem;
  height: 0.4rem;
  padding-left: 0.1rem;
  cursor: pointer;
  position: relative;

  &.block {
    .un-login-content {
      display: block !important;
    }
  }

  &:hover {
    .un-login-content {
      display: block;
    }
  }
}

.un-login-content {
  display: none;
  clear: both;
  width: 3.64rem;
  height: 5.19rem;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.05rem;
  border-radius: 0.1rem;
  position: absolute;
  z-index: 5;
  width: 3.64rem;
  height: 5.19rem;
  top: 0.35rem;

  background-image: url("~@/components/header/login-bg.png");
  background-size: 100% 100%;
  color: #666;

  .login-content {
    display: block;
    clear: both;
    width: calc(100% - 0.21rem);
    height: calc(100% - 0.1rem);
    overflow: hidden;
    box-sizing: border-box;
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
    top: 0.1rem;
    left: 0.14rem;

    .title {
      text-align: center;
      margin-top: 0.06rem;
      font-size: 0.18rem;
      color: #fff;
    }
  }

  .icon-text {
    width: 100%;
    height: 0.4rem;
    font-size: 0.18rem;
    font-weight: 500;
    line-height: 0.25rem;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: -0.39rem;
    margin-left: 0.2rem;
  }

  .icon-img {
    margin-top: 0.2rem;
    width: 100%;
    height: 0.52rem;
  }

  .un-login-title {
    font-size: 0.16rem;
    color: #333;
    line-height: 0.22rem;
  }

  .login-now {
    line-height: 0.37rem;
    text-align: center;
    display: block;
    width: 100%;
    height: 0.37rem;
    background: transparent;
    border-radius: 0.05rem;
    color: #fff;
    font-size: 0.12rem;
    margin: 0.6rem auto 0.02rem;
  }
}

.login-bg {
  background-image: url("~@/components/header/out-bg.png");
}

.header {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  height: 0.72rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: url("/img/home-back.png") no-repeat;
  background-size: 100%;

  .wraper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 14rem;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 0.04rem;
  }

  .main_logo {
    width: 1.35rem;
    margin-right: 0.2rem;
  }

  .main_logo img {
    display: block;
    width: 1.35rem;
  }

  .link {
    display: flex;
    align-items: center;
    position: relative;
    gap: 0.08rem;

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      color: #666666;
      cursor: pointer;
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 500;
      padding: 5px 15px;
      position: relative;

      img {
        &.act {
          display: none;
        }
      }

      &.tab-wc {
        white-space: nowrap;

        img {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        .tab-label {
          white-space: nowrap;
        }
      }

      &:hover {
        img {
          display: none;

          &.act {
            display: block;
          }
        }

        color: #ffffff;
      }
    }

    .active-select {
      color: #ffffff !important;
      font-weight: 500;

      img {
        display: none;

        &.act {
          display: block;
        }
      }
    }
  }

  .home-header-links {
    a {
      &:hover {
        color: #000;
        box-shadow: 0px 0px 1px 1px #29f19c;
      }

      &:hover:before {
        background-image: none;
      }

      &:hover:after {
        background-color: transparent;
      }
    }
  }

  .header-left {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }

  .header-right {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    float: right;
    width: 4.8rem;
    height: 100%;
    gap: 0.1rem;
  }

  .search_bar_gray {
    display: flex;
    justify-content: space-between;
    float: left;
    position: relative;
    padding-left: 0.15rem;
    padding-right: 0.1rem;
    width: 2.4rem;
    height: 0.36rem;
    border: 0.5px solid #666666;

    & > input.search-input {
      display: block;
      float: left;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      line-height: 0.4rem;
      color: #ffffff;
      background: transparent;
      outline: none;
      border: none;
      font-size: 0.14rem;
    }

    & > input::placeholder {
      left: 0.2rem;
      color: #666666;
    }

    .search-input::-webkit-input-placeholder,
    .search-input:-moz-placeholder,
    .search-input::-moz-placeholder,
    .search-input:-ms-input-placeholder {
      color: #999999 !important;
    }

    & > img {
      display: block;
      float: right;
      width: 0.2rem;
      cursor: pointer;
      position: absolute;
      z-index: 2;
      right: 0.1rem;
      top: 0.08rem;
    }
  }

  .controller {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;

    & > button {
      min-width: 0.86rem;
      display: flex;
      align-items: center;
      margin-right: 0.06rem;
      font-size: 0.17rem;
      color: #fff;
      background: transparent;
      cursor: pointer;
      width: 0.96rem;
      height: 0.34rem;
      background-image: linear-gradient(90deg, #58c0ab 0%, #379f9f 50%, #157e93 100%),
        linear-gradient(#28ba74, #28ba74);
      background-blend-mode: normal, normal;
      border-radius: 0.03rem;
      justify-content: center;

      & > img {
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.05rem;
      }
    }

    .message-icon {
      margin-right: 0.1rem;
      position: relative;

      & > span {
        position: absolute;
        right: -0.05rem;
        top: -0.05rem;
        padding: 0 0.05rem;
        height: 0.2rem;
        box-sizing: border-box;
        min-width: 0.2rem;
        line-height: 0.2rem;
        background: red;
        border-radius: 50%;
        font-size: 0.12rem;
        color: #fff;
        text-align: center;
      }

      .message {
        font-size: 0.24rem;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .start-btn,
    .login-btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      float: left;
      width: auto;
      height: 100%;
      cursor: pointer;
      color: #fff;
      position: relative;
      margin: 0 0.02rem;

      .icon {
        display: block;
        clear: both;
        width: 0.5rem;
        height: 0.25rem;
        overflow: hidden;
        box-sizing: border-box;

        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }

      p {
        clear: both;
        width: 100%;
        height: 0.2rem;
        line-height: 0.2rem;
        overflow: hidden;
        font-size: 0.12rem;
        color: #ccc;
        text-align: center;
      }

      div {
        position: absolute;
        bottom: -0.24rem;
      }

      .tip-img {
        width: 100%;
        height: 100%;
      }
    }

    .start-btn .icon .img-normal {
      display: block;
    }

    .start-btn .icon .img-active {
      display: none;
    }

    .start-btn:hover .icon .img-normal {
      display: none;
    }

    .start-btn:hover .icon .img-active {
      display: block;
    }

    .start-btn:hover p {
      color: #fff;
    }

    .homeheader .start-btn:hover p {
      color: #fff;
    }

    .img-login {
      width: 100%;
    }

    .login,
    .download {
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;

      .own-live {
        font-size: 0.12rem;
        margin-right: 0.1rem;
        cursor: pointer;
        font-weight: 600;
      }

      & > img {
        width: 0.2rem;
        height: 0.2rem;
        margin-left: 0.06rem;

        &.avatar {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      & > p {
        font-size: 0.12rem;
        font-weight: 600;
        color: #333;

        &.nickname {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 0.6rem;
        }

        &:nth-child(2) {
          padding-left: 0.06rem;
          padding-right: 0.04rem;
        }

        &:nth-child(3) {
          padding-left: 0.04rem;
          border-left: 0.01rem solid #eee;
        }
      }
    }

    .login {
      width: 0.7rem;
      height: 0.34rem;
      border-radius: 0.03rem;
      background-color: #021e24;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .login p {
      font-size: 0.16rem;
      margin: 0 0.09rem;
      color: #24a39c;
      font-weight: 600;
    }

    .login2 {
      width: 0.44rem;
      height: 0.4rem;
      border-radius: 0.03rem;
      position: relative;
      border-radius: 0.03rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0.05rem;

      .un-login-content {
        right: -0.77rem !important;
      }

      &:hover {
        .un-login-content {
          display: block;
        }
      }

      & > img {
        width: 0.2rem;
        height: 0.2rem;
        margin-left: 0.06rem;
      }

      .avatar {
        width: 0.39rem;
        height: 0.39rem;
        border-radius: 50%;
        object-fit: cover;
      }

      .note {
        position: absolute;
        top: -0.04rem;
        right: 0px;
        padding: 0 0.05rem;
        min-width: 0.1rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 0.2rem;
        background: #f64d5c;
        color: #ffffff;
        font-size: 0.12rem;
        margin-left: 0.06rem;
      }
    }

    .download {
      margin-right: 0.2rem;
      text-decoration: none;
    }
  }
}

.homeheader {
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: overlay;
}

.otherheader {
  background-image: none;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #fff;
  border-bottom: 1px solid #dcdcdf;

  .controller {
    .start-btn {
      color: #999;

      &:hover {
        color: #666;
      }
    }

    .login-btn {
      color: #666666;
    }
  }
}

.world_cup_header {
  background-color: #480433;
  border-bottom: 2px solid #000;

  .link {
    a {
      color: rgba(255, 255, 255, 0.75);

      &:hover,
      &.wc_nav_select {
        color: #fff;
        background-color: #a8032b;
        box-shadow: none;
      }

      &.wc_nav_select {
        font-weight: bold;
      }
    }
  }
}

.livenav {
  position: relative;
  cursor: pointer;
}

.subnav-wrap {
  position: absolute;
  left: 0.32rem;
  top: 0.35re;
  width: 1.3rem;
  background-color: #fff;
  font-size: 0.12rem;
  box-shadow: 0 0.02rem 0.12rem 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 0.13rem 0.16rem;

  & > a {
    display: inline-block;
    line-height: 0.3rem;
    color: #333;
    font-size: 0.15rem;
    margin: 0 0.12rem;

    &:hover {
      color: $theme-color;
    }
  }
}

.aa {
  width: 100%;
  height: 100%;
  background-image: url(./img/icon-1.png);
}

.chat-assistant-modal {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;

  .chat-assistant-panel {
    width: min(11.2rem, 92vw);
    height: min(7.2rem, 86vh);
    background: #fff;
    border-radius: 0.12rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0.12rem 0.4rem rgba(0, 0, 0, 0.25);
  }

  .chat-assistant-header {
    height: 0.48rem;
    padding: 0 0.16rem;
    background: #20232b;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;

    .title {
      color: #fff;
      font-size: 0.16rem;
      font-weight: 500;
    }

    .collapse {
      color: #fff;
      font-size: 0.14rem;
      cursor: pointer;
      opacity: 0.9;

      &:hover {
        opacity: 1;
      }
    }
  }

  .chat-assistant-iframe {
    flex: 1;
    width: 100%;
    border: 0;
    background: #fff;
  }
}
</style>
